/**
 * UI-тексты страницы «Все отели города» (AllHotelsPageContent).
 * Вертикаль-специфика: герой, навигация, секции карты и списка, фасетные
 * фильтры (поиск/цена/звёзды/район/удобства/сортировка), мета и нижний CTA.
 * Общих надзаголовков/якорей/тегов servicePage эта страница не использует.
 * Интерполируемые строки — функции; выбор локализованного значения,
 * Intl-форматирование и склонения остаются в компоненте.
 */
export const allHotelsPage = {
    en: {
        // Лейблы удобств для фасетных чипов (порядок = приоритет)
        amenity: {
            spa: 'Spa',
            pool: 'Pool',
            seaFront: 'Seafront',
            beach: 'Private beach',
            fitness: 'Gym',
            parking: 'Parking',
            pets: 'Pet friendly',
            ruStaff: 'Russian-speaking',
            breakfast: 'Breakfast',
            family: 'Family',
        },

        // Навигация
        leaf: 'Hotels',
        crumbCities: 'Cities',
        anchorMap: 'Map',
        anchorList: 'All hotels',

        // Hero
        heroTitle: (city) => `Hotels in ${city}`,
        heroSub: 'Every hand-picked hotel in the city on one page — with a map, prices and direct booking.',

        // Map section
        mapEyebrow: (city) => `${city}. Map`,
        mapTitle: 'Hotels on the map',
        mapLead: 'Where the hotels sit relative to the centre — to pick the right area.',

        // List section
        listEyebrow: (city) => `${city}. Hotels`,
        listTitle: 'All hotels',
        listLead: 'Filter by price, class, area and amenities — or search a hotel by name.',

        // Filters
        searchPlaceholder: 'Search by name or area…',
        searchAria: 'Search hotels',
        areaAria: 'Area',
        allAreas: (n) => `All areas (${n})`,
        sortAria: 'Sort',
        sort: {
            featured: 'Recommended',
            rating: 'Top rated',
            distance: 'Closest to centre',
            priceAsc: 'Price: low → high',
            priceDesc: 'Price: high → low',
        },
        priceTitle: 'Price',
        starsTitle: 'Stars',

        // Meta / empty state
        countOf: (shown, total) => `${shown} of ${total}`,
        reset: 'Reset',
        empty: 'Nothing found — adjust your search or filter.',

        // Bottom CTA
        ctaEyebrow: 'Didn’t find the right fit?',
        ctaTitle: 'Find more options',
        searchBooking: 'Search on Booking.com',
        searchTrip: 'Search on Trip.com',
    },
    ru: {
        amenity: {
            spa: 'Спа',
            pool: 'Бассейн',
            seaFront: 'Первая линия',
            beach: 'Свой пляж',
            fitness: 'Фитнес',
            parking: 'Парковка',
            pets: 'С питомцами',
            ruStaff: 'Русскоговорящий персонал',
            breakfast: 'Завтрак',
            family: 'Для семей',
        },

        leaf: 'Отели',
        crumbCities: 'Города',
        anchorMap: 'Карта',
        anchorList: 'Все отели',

        heroTitle: (city) => `Отели в городе ${city}`,
        heroSub: 'Все проверенные отели города на одной странице — с картой, ценами и прямым бронированием.',

        mapEyebrow: (city) => `${city}. Карта`,
        mapTitle: 'Отели на карте',
        mapLead: 'Расположение отелей относительно центра — чтобы выбрать удобный район.',

        listEyebrow: (city) => `${city}. Отели`,
        listTitle: 'Все отели',
        listLead: 'Отфильтруйте по цене, классу, району и удобствам — или найдите отель по названию.',

        searchPlaceholder: 'Поиск по названию или району…',
        searchAria: 'Поиск отелей',
        areaAria: 'Район',
        allAreas: (n) => `Все районы (${n})`,
        sortAria: 'Сортировка',
        sort: {
            featured: 'Рекомендуемые',
            rating: 'По рейтингу',
            distance: 'Ближе к центру',
            priceAsc: 'Цена: дешевле',
            priceDesc: 'Цена: дороже',
        },
        priceTitle: 'Цена',
        starsTitle: 'Звёзды',

        countOf: (shown, total) => `${shown} из ${total}`,
        reset: 'Сбросить',
        empty: 'Ничего не найдено — измените запрос или фильтр.',

        ctaEyebrow: 'Не нашли подходящий вариант?',
        ctaTitle: 'Искать ещё варианты',
        searchBooking: 'Искать на Booking.com',
        searchTrip: 'Искать на Trip.com',
    },
};
